export default __webpack_public_path__ + "static/media/q18.c50387ab.png";